import React from 'react'
import PropTypes from 'prop-types'
import { makePaper } from './styled'

export const RawPaper = makePaper('section')

function Paper(props) {
  return <RawPaper {...props}></RawPaper>
}

Paper.propTypes = {
  bgColor: PropTypes.string,
}

export default Paper
